module.exports = "pegasus/assets/hexagon-youtube.gif";